(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/utils/engine.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/utils/engine.js');

'use strict';

const {
  couponValues,
  quickpickProps
} = svs.racing.common.constants;
const errors = svs.racing.gameEngine.errors;
const isAvailable = value => value !== couponValues.CANCELED;
const isPosition = value => !isNaN(value);
const indexToPosition = index => index + 1;
const positionToIndex = position => position - 1;
const countPositions = function (row) {
  let conditionFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return row.reduce((accummulator, value, index) => {
    if (conditionFn) {
      if (conditionFn(value, index)) {
        return accummulator + 1;
      }
    } else if (isPosition(value)) {
      return accummulator + 1;
    }
    return accummulator;
  }, 0);
};

const parseData = function (row, data) {
  let positionBased = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let validationFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  let reserveValidationFn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  let numSelectionMismatches = new Set();

  let numMismatches = 0;
  const assignedNewValues = {};
  const parsedRow = row.map((value, index) => {
    const newValue = data.row[index];

    if (newValue) {
      if (isPosition(newValue)) {
        if (!isAvailable(value)) {
          numSelectionMismatches.add(index);
          return value;
        }
        if (positionBased) {
          if (newValue <= 0 || newValue > row.length) {
            return value;
          }

          if (assignedNewValues[newValue]) {
            return value;
          }
          assignedNewValues[newValue] = true;
        }
        if (validationFn && !validationFn(value, newValue, index)) {
          return value;
        }
        return newValue;
      }

      if (isAvailable(value)) {
        numMismatches++;
      }

      return value;
    } else if (!isAvailable(value)) {

      numMismatches++;
    }
    return value;
  });
  const reserveIndex = data.reserve;
  let parsedReserve;
  if (reserveIndex !== undefined) {
    if (reserveIndex >= 0 && reserveIndex < parsedRow.length) {
      const reserveValue = parsedRow[reserveIndex];
      if (isAvailable(reserveValue)) {
        if (reserveValidationFn) {
          if (reserveValidationFn(reserveIndex, reserveValue)) {
            parsedReserve = reserveIndex;
          }
        } else {
          parsedReserve = reserveIndex;
        }
      } else {
        numSelectionMismatches.add(reserveIndex);
      }
    } else if (reserveIndex === -1) {
      parsedReserve = reserveIndex;
    }
  }
  numSelectionMismatches = numSelectionMismatches.size;
  let error;
  if (data.qpValue !== quickpickProps.WEIGHTEDQP && numSelectionMismatches > 0) {
    error = {
      type: errors.INVALID_SELECTION,
      numInvalid: numSelectionMismatches
    };
  } else if (data.qpValue !== quickpickProps.WEIGHTEDQP && numMismatches > 0) {
    error = {
      type: errors.INVALID_COUPON,
      numInvalid: numMismatches
    };
  }
  return {
    row: parsedRow,
    reserve: parsedReserve,
    error
  };
};
svs.racing.gameEngine.utils.engine = {
  isPosition,
  isAvailable,
  indexToPosition,
  positionToIndex,
  countPositions,
  parseData
};

 })(window);